module.exports = __webpack_public_path__ + "media/images/loader-63d7da1bc33c0063002c97e734993b43.gif";